module.exports = __webpack_public_path__ + "img/9788972757337.98da7548.jpg";